import React, { useEffect, useState } from "react";
import styles from "../../styles/dashboard.module.scss";
import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";
import Summary from "./Summary";
import DepartmentsWellnessProgressBar from "./DepartmentsWellnessProgressBar";
import OverallWellnessIndexPieChart from "./OverallWellnessIndexPieChart";
import HappinessBarchart from "./HappinessBarchart";
import OverallHappinessIndex from "./OverallHappinessIndex";
import WellnessBarchart from "./WellnessBarchart";
import Engagement from "./Engagement";
import TeamMoodOverview from "./TeamMoodOverview";
import Deptgrid from "../overview/deptgrid";


function Insights() {
  const [overallLevel, setoverallLevel] = useState<any>();
  const { getUserByID } = useB2BContext();

  const [year, setYear] = useState(new Date().getFullYear());

  const changeYear = (offset: any) => {
    setYear((prevYear) => prevYear + offset);
  };

  useEffect(() => {
    const month: any = moment().format("M");
    const year: any = moment().format("yyyy");

    authSVC
      .getoverAllViewLevels(getUserByID?.company, Number(month), Number(year))
      .then((res) => {
        setoverallLevel(res?.data?.data[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [getUserByID]);

  return (
    <>
      <div className="year_selection_wrapper">
        <div className="flex gap-4 mt-2">
          <button
            className="px-4 py-2 bg-red-500 text-white rounded-lg"
            onClick={() => changeYear(-1)}
          >
            <img
              src="/img/arrowRight_rounded.svg"
              alt=""
              width={20}
              height={20}
            />
          </button>
          <h2 className="text-xl font-bold">Year: {year}</h2>
          <button
            className="px-4 py-2 bg-green-500 text-white rounded-lg"
            onClick={() => changeYear(1)}
          >
            <img
              src="/img/arrowLeft_rounded.svg"
              alt=""
              width={20}
              height={20}
            />
          </button>
        </div>
      </div>
      {/* <div className="top_info">
        <img src="/img/Group19216.svg" alt="" />{" "}
        <p>A lower index value indicates a less confused mental state.</p>
      </div> */}
      <div className={styles.wellness_report_main_wrapper}>
        <div className={styles.col_2_div}>
          <div className={styles.data_container}>
            <WellnessBarchart year={year} />
            <Deptgrid />
            <h2 className="section_title" style={{marginTop: 32}}>Overall Report</h2>
            <Summary overallLevel={overallLevel} />
            {/* <OverallWellnessIndexPieChart levelsData={levelsData} /> */}
          </div>
          <div className={styles.data_container}>
            <HappinessBarchart year={year} />
            <Engagement />
            <TeamMoodOverview />
            <div style={{  marginBottom: "32px"}}></div>
            {/* <OverallHappinessIndex levelsData={levelsData} /> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default Insights;
